// removed by extract-text-webpack-plugin
module.exports = {"root":"more-links__root","header":"more-links__header","title":"more-links__title","list":"more-links__list","item":"more-links__item","itemLink":"more-links__itemLink","iconLink":"more-links__iconLink","itemIcon":"more-links__itemIcon"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/show-page/components/more-links/styles.less
 ** module id = 217
 ** module chunks = 1
 **/